import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { S3_SM_TRANNING_DOC_FOLDER } from 'helpers/urlHelper';

import DocumentBaseModal from './DocumentBaseModal';
export const SMTrainingDocRecordApp = 'sm.training.doc.record';
const RecordDocumentModal = ({
  isShow,
  handleClose,
  onSubmit,
  trainingId,
  trainee,
}) => {
  const app = SMTrainingDocRecordApp;
  const title = "Record's Documents";
  const [documentFolder, setDocumentFoloder] = useState('');
  const [recordValue, setRecordValue] = useState('');

  useEffect(() => {
    setDocumentFoloder(
      S3_SM_TRANNING_DOC_FOLDER +
        `/Records/${trainingId}`
    );

    setRecordValue(`${trainingId}`);
  }, [trainingId]);
  return (
    <DocumentBaseModal
      isShow={isShow}
      handleClose={handleClose}
      onSubmit={onSubmit}
      app={app}
      recordValue={recordValue}
      documentFolderParam={documentFolder}
      title={title}
      recordId={recordValue}
      trainee={trainee}
    />
  );
};
RecordDocumentModal.propTypes = {
  isShow: PropTypes.bool,
  handleClose: PropTypes.func,
  onSubmit: PropTypes.func,
  skillLevelId: PropTypes.number.isRequired,
  sectionId: PropTypes.number.isRequired,
  areaId: PropTypes.number.isRequired,
  trainingId: PropTypes.number,
  trainee: PropTypes.number,
};

export default RecordDocumentModal;
